export const CONTACT_US_URL = 'https://share.hsforms.com/1ZQUJ4CMBTKS551hzcn8nMw4rhvg';

export const READ_ONLY_LABEL = ' - (read only mode)';
